import { useState, useCallback } from 'react';

export function useUrlParam(key, defaultValue = null) {
  const [value, setValue] = useState(() => {
    const param = new URLSearchParams(window.location.search).get(key);
    return param !== null ? param : defaultValue;
  });

  const setParam = useCallback((newValue) => {
    setValue(newValue);
    const params = new URLSearchParams(window.location.search);
    if (newValue == null) {
      params.delete(key);
    } else {
      params.set(key, String(newValue));
    }
    const qs = params.toString();
    window.history.replaceState(null, '', qs ? `?${qs}` : window.location.pathname);
  }, [key]);

  return [value, setParam];
}
